import request from '@/utils/request'

export function listCategories(scope) {
  return request({ url: '/dkmall/categories', method: 'get', params: { scope } })
}

export function addCategory(scope, data) {
  return request({ url: '/dkmall/categories', method: 'post', params: { scope }, data })
}

export function updateCategory(scope, data) {
  return request({ url: '/dkmall/categories', method: 'put', params: { scope }, data })
}

export function deleteCategory(scope, aid) {
  return request({ url: `/dkmall/categories/${aid}`, method: 'delete', params: { scope } })
}

export function toggleCategoryStatus(scope, aid) {
  return request({ url: `/dkmall/categories/${aid}/status`, method: 'put', params: { scope } })
}

export function pageGoods(query) {
  return request({ url: '/dkmall/goods/page', method: 'get', params: query })
}

export function setGoodsSale(aid, onSale) {
  return request({ url: `/dkmall/goods/${aid}/sale`, method: 'put', params: { onSale } })
}

export function getGoods(aid, orderType) {
  return request({ url: `/dkmall/goods/${aid}`, method: 'get', params: { orderType } })
}

export function addGoods(data) {
  return request({ url: '/dkmall/goods', method: 'post', data })
}

export function updateGoods(data) {
  return request({ url: '/dkmall/goods', method: 'put', data })
}

export function deleteGoods(aid, orderType) {
  return request({ url: `/dkmall/goods/${aid}`, method: 'delete', params: { orderType } })
}

export function pageSubProducts(params) { return request({ url: '/dkmall/goods/accessories/page', method: 'get', params }) }
export function addSubProduct(data) { return request({ url: '/dkmall/goods/accessories', method: 'post', data }) }
export function updateSubProduct(data) { return request({ url: '/dkmall/goods/accessories', method: 'put', data }) }
export function getSubProductParent(aid) { return request({ url: `/dkmall/goods/accessories/${aid}/parent`, method: 'get' }) }
